var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartphone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7204 0.187625H2.46381C1.55182 0.187625 0.8125 0.926941 0.8125 1.83893V16.3487C0.8125 17.2607 1.55182 18 2.46381 18H10.7204C11.6323 18 12.3717 17.2607 12.3717 16.3487V1.48692C12.3717 0.574925 11.6323 0.187625 10.7204 0.187625ZM2.08821 1.48692L4.11479 1.48821C4.11479 2.47899 5.31043 2.47899 5.76643 2.47899H7.41773C7.87373 2.47899 9.06872 2.47899 9.06872 1.48821L11.0934 1.48692V16.7135H2.08821V1.48692Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.08715 9.28097C8.45514 9.28097 9.56411 10.3899 9.56411 11.7579V12.7487H3.6194V11.7579C3.6194 10.3899 4.72838 9.28097 6.09636 9.28097H7.08715ZM6.5916 5.81387C7.41239 5.81387 8.07777 6.47925 8.07777 7.30004C8.07777 8.12084 7.41239 8.78622 6.5916 8.78622C5.7708 8.78622 5.10542 8.12084 5.10542 7.30004C5.10542 6.47925 5.7708 5.81387 6.5916 5.81387Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphone);
export default __webpack_public_path__ + "static/media/smartphone.e6ac44c6.svg";
export { ForwardRef as ReactComponent };